import { connectedScaleSocket, setScaleWeightInfo } from '../actions/scale-socket';
import config from '../constants/config';
import store from '../store';

class WebSocketScaleClient {
    constructor() {                
        this.isConnected = false;  
        this.isPrintLog = false;
        this.connect = this.connect.bind(this);      
        this.destroy = this.destroy.bind(this);
        this.parseJSON = this.parseJSON.bind(this);
        this.infoLog = this.infoLog.bind(this);
    }

    connect(callback) {
       // if (!config.remotescalesocket.IS_ENABLE) return callback('Websocket connectivity is disabled!');

        const me = this;
        this.destroy();

        const websocketUrl = config.remotescalesocket.SOCKET_URL;
        this.socket = new WebSocket(websocketUrl);

        this.socket.onmessage = (event) => {
            const message = event.data ? me.parseJSON(event.data) : null;
            if (!message) return;
            store.dispatch(setScaleWeightInfo(message)) 
            this.infoLog(message, "onMessage");
        };

        this.socket.onopen = () => {
            this.infoLog('Websocket:=> connected');
            me.isConnected = true;           
            return callback();
        };

        this.socket.onerror = (err) => {
            this.infoLog('Websocket:=> Error : ' + err);
        };

        this.socket.onclose = () => {
            this.infoLog('Websocket:=> Disconnected');
            store.dispatch(connectedScaleSocket(false))
            me.isConnected = false;
            me.interval = window.setInterval(() => {
                if (me.isConnected) {
                    clearInterval(me.interval);
                    me.interval = null;
                    return;
                }

                this.infoLog('Websocket:=> Reconnecting...');
                me.connect(callback);
            }, 1500000);
        };
    }
    
    destroy() {
        if (this.socket) {
            this.socket.close();
            delete this.socket;
            this.socket = null;
        }
    }

    parseJSON(message) {
        try {
            return JSON.parse(message);
        } catch (error) {
            return null;
        }
    }

    infoLog(msg, type) {
        if (this.isPrintLog) console.log(msg, type);
    }
}

export default WebSocketScaleClient;